export const useUser = () => {
  const user = useState<any>("user", () => null);

  // fetch user data
  const fetchUser = async () => {
    const { data } = await useFetch("/api/user", {
      key: "userData",
    });

    user.value = data.value;
  };
  const clearUser = () => {
    user.value = null;
  };
  return {
    user,
    fetchUser,
    clearUser,
  };
};
